import React from "react";
import Proptypes from "prop-types";

const ArrowUp = ({ size = 16, color = "currentColor", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 15V1M15 8L8 1L1 8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowUp;

ArrowUp.propTypes = {
  size: Proptypes.number,
  color: Proptypes.string,
};
